import getPresence from 'utilities/getPresence';

const presenceValues = {
  Online: 1,
  Unavailable: 2,
  Offline: 3,
};

const sortAgentLoggedInUser = (agentA, loggedInUser) => {
  if (agentA.id === loggedInUser.id) return -1;
  return 1;
};

const sortAgentName = (agentA, agentB) => {
  var nameA = agentA.full_name.toUpperCase();
  var nameB = agentB.full_name.toUpperCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
};

const sortAgentPresence = (loggedInUser = {}) => (agentA, agentB) => {
  if (agentA.id === loggedInUser.id || agentB.id === loggedInUser.id) {
    return sortAgentLoggedInUser(agentA, loggedInUser);
  }
  const presenceA = getPresence(
    agentA.presence,
    agentA.web_available || agentA.mobile_available
  );
  const presenceB = getPresence(
    agentB.presence,
    agentB.web_available || agentB.mobile_available
  );

  if (presenceA === presenceB) {
    return sortAgentName(agentA, agentB);
  }
  return presenceValues[presenceA] - presenceValues[presenceB];
};

export const sortVisibleAgents = (state) => {
  const loggedInUser = state.appState?.loggedInUser;
  return [...state.visible_agents].sort(sortAgentPresence(loggedInUser));
};
